import { render } from "./person-select.vue?vue&type=template&id=cc6cc91c&scoped=true"
import script from "./person-select.vue?vue&type=script&lang=js"
export * from "./person-select.vue?vue&type=script&lang=js"

import "./person-select.vue?vue&type=style&index=0&id=cc6cc91c&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc6cc91c"]])

export default __exports__